import { eventSoundMap } from './sounds.js';
import { getSoundManager } from './useSounds.js';

/**
 * Preload (decode) the given sound IDs into the SoundManager buffer cache
 * so the first play is hitch-free. No-op for synth-mode sounds.
 */
export async function preloadCriticalSfx(soundIds: readonly string[]): Promise<void> {
  const manager = getSoundManager();
  if (!manager.isInitialized) manager.init();
  await manager.preloadMany(soundIds);
}

/**
 * Return the unique set of sound IDs referenced by the event sound map.
 * These are the sounds that will fire during normal match play.
 */
export function getMatchCriticalSoundIds(): readonly string[] {
  return Array.from(new Set(Object.values(eventSoundMap)));
}
